import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Footer/Footer.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'
import WebComponent from '../../WebComponent.js'
import FooterService from './FooterService.js'

export default class Footer extends WebComponent {

  get translationFile() {
    return './views/Footer/i18n.json'
  }

  get css() {
    return css`
      ul {
        list-style-type: none;
        margin: 0;
      }

      a {
        text-decoration: none;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
    this.version = ''
  }

  reload() {
    const service = new FooterService()
    Promise.all([
      service.list(), fetch('./version.json', {cache: 'reload'}).then(r => r.json())
    ])
      .then(([backend, frontend]) => {
        this.version = `- (v${frontend.version}/${backend.version})`
        this.render()
      }).catch(_ => {
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-footer text="${this.i18n.translate('footer.text')} ${this.version}">
        <ul>
          <li>
            <isceco-link url="${this.i18n.translate('footer.rechtliches.link')}"
                         text="${this.i18n.translate('footer.rechtliches')}"
                         target="_blank"></isceco-link>
          </li>
        </ul>
      </isceco-footer>
    `
  }
}

customElements.define('eform-frontend-footer', Footer)
